import { TimelineCardEvent } from '../components/TimelineListItem/types';
import { SignalRData, SignalRLocation, SignalRSite, SignalRChannel } from '../types/signalr-types';
import _ from 'lodash';
import { RecordData, isRecordFound } from '../hooks/data-hooks';
import { isDataLoaded, Data } from '../types';
import { getPrecisionValue } from './precision-helper';
import { DeviceChannelData } from '../types/device';
import { Device } from '../api/types';

export const initialSignalRData: SignalRData = { locations: [] };

export function createTimelineCurrentData(alarm: {
    alarmId: string;
    trigger: string;
    severity: string;
    channelName: string;
    unit: string;
    ackLevel: number;
    status: string;
    deviceId: string;
    deviceName: string;
    path: string[];
    value: string;
    threshold: string;
    dateTime: string;
}): TimelineCardEvent {
    return {
        alarmId: alarm.alarmId,
        trigger: alarm.trigger,
        severity: alarm.severity,
        channelName: alarm.channelName,
        unit: alarm.unit,
        value: alarm.value,
        deviceId: alarm.deviceId,
        deviceName: alarm.deviceName,
        dateTime: alarm.dateTime,
        channelId: null,
        path: alarm.path,
        status: alarm.status,
    };
}

function getRecentTimelineDataByLocationId(
    location: SignalRLocation | undefined,
    newTimeline: TimelineCardEvent[],
    selectedSiteId?: string
): void {
    _.filter(location && location.sites, (updatedSite: SignalRSite | undefined) => {
        /* eslint-disable no-param-reassign */
        if (selectedSiteId && selectedSiteId !== '' && location) {
            updatedSite = _.find(location.sites, { siteId: selectedSiteId });
        }
        _.forEach(updatedSite && updatedSite.alarmStatus, (alarm) => {
            const obj = createTimelineCurrentData(alarm);
            const notExist = newTimeline.every((arr) => arr.alarmId !== obj.alarmId);
            if (notExist) newTimeline.push(obj);
        });
    });
}

export function getRecentTimelineData(
    recentData: SignalRData,
    locations?: RecordData<{
        id: string;
        name: string;
        alarmCount?: number | undefined;
    }>,
    selectedSiteId?: string
): TimelineCardEvent[] {
    const newTimeline: TimelineCardEvent[] = [];
    if (locations && isRecordFound(locations)) {
        const selectedLocation: SignalRLocation | undefined = _.find(recentData.locations, {
            locationId: locations.value.id,
        });
        getRecentTimelineDataByLocationId(selectedLocation, newTimeline, selectedSiteId);
    } else {
        _.filter(recentData.locations, (location) => {
            getRecentTimelineDataByLocationId(location, newTimeline);
        });
    }
    return newTimeline;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUpdateChannelData(channelData: any, siteChannelData: Data<any>): Data<any> {
    if (channelData && channelData.length > 0 && isDataLoaded(siteChannelData)) {
        _.filter(channelData, (newchannelData) => {
            _.filter(siteChannelData.value, (exsitingChannel) => {
                if (exsitingChannel.id === newchannelData.channelId)
                    exsitingChannel.value = getPrecisionValue(newchannelData.value);
            });
        });
    }
    return Object.assign({}, siteChannelData);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUpdateChannelDataWithDevideId(channelData: any, siteChannelData: Data<any>): Data<any> {
    if (channelData && channelData.length > 0 && isDataLoaded(siteChannelData)) {
        _.filter(channelData, (newchannelData) => {
            _.filter(siteChannelData.value, (exsitingChannel) => {
                if (
                    exsitingChannel.id === newchannelData.channelId &&
                    exsitingChannel.deviceId === newchannelData.deviceId
                )
                    exsitingChannel.value = getPrecisionValue(newchannelData.value);
            });
        });
    }
    return Object.assign({}, siteChannelData);
}
export function getUpdatedLocation(
    recentLocations: SignalRLocation[],
    locationId: string
): SignalRLocation | undefined {
    return _.find(recentLocations, { locationId: locationId });
}

export function getUpdatedChannelListForTimeline(
    deviceId: string,
    siteRealChannelData: SignalRChannel[],
    deviceChannelDetails: DeviceChannelData[]
): DeviceChannelData[] {
    _.filter(siteRealChannelData, (newchannelData) => {
        _.filter(deviceChannelDetails, (exsitingChannel) => {
            if (exsitingChannel.id === newchannelData.channelId && deviceId === newchannelData.deviceId)
                exsitingChannel.value = getPrecisionValue(newchannelData.value);
        });
    });
    return [...deviceChannelDetails];
}

export function getUpdatedDeviceStatusList(realtimeDeviceStatus: any, siteAPIDeviceStatus: Data<any>): Data<any> {
    if (realtimeDeviceStatus && realtimeDeviceStatus.length > 0 && isDataLoaded(siteAPIDeviceStatus)) {
        _.filter(realtimeDeviceStatus, (newdeviceStatus) => {
            _.filter(siteAPIDeviceStatus.value, (exsitingDeviceStatus) => {
                if (exsitingDeviceStatus.id === newdeviceStatus.deviceId) {
                    exsitingDeviceStatus.status = newdeviceStatus.status;
                }
            });
        });
    }
    return Object.assign({}, siteAPIDeviceStatus);
}

export function getUpdatedChildDeviceStatusList(realtimeDeviceData: any, childDeviceAPIList: Device[]): Device[] {
    if (realtimeDeviceData && realtimeDeviceData.length > 0) {
        _.filter(realtimeDeviceData, (newdeviceStatus) => {
            _.filter(childDeviceAPIList, (exsitingDeviceStatus) => {
                if (exsitingDeviceStatus.id === newdeviceStatus.deviceId) {
                    exsitingDeviceStatus.status = newdeviceStatus.status;
                }
            });
        });
    }
    return Object.assign([], childDeviceAPIList);
}
